import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M29.417 9.127a3.506 3.506 0 0 0-2.476-2.475C24.756 6.066 16 6.066 16 6.066s-8.756 0-10.94.586a3.506 3.506 0 0 0-2.475 2.475C2 11.31 2 15.867 2 15.867s0 4.557.585 6.74a3.506 3.506 0 0 0 2.476 2.475c2.183.585 10.939.585 10.939.585s8.756 0 10.94-.585a3.507 3.507 0 0 0 2.475-2.476c.585-2.182.585-6.74.585-6.74s0-4.556-.585-6.739h.002Zm-16.218 10.94v-8.4l7.275 4.2-7.274 4.2Z" stroke="none"></path>';
export var YouTubeSVG = function YouTubeSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
YouTubeSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(YouTubeSVG);